import { AgentDetails } from '@zet/utils/interface'
import { create } from 'zustand'

type Store = {
  user: AgentDetails | null
  setUser: (agent: AgentDetails | null) => void
  selectedDsaId: number | null
  setSelectedDsaId: (payload: number) => void
  partnerId: null | number
  setPartnerId: (payload: number) => void
}
const useStore = create<Store>((set) => ({
  user: null,
  setUser: (agent) => set((state) => ({ ...state, user: agent })),
  selectedDsaId: null,
  setSelectedDsaId: (payload) =>
    set((state) => ({ ...state, selectedDsaId: payload })),
  partnerId: null,
  setPartnerId: (payload) => set((state) => ({ ...state, partnerId: payload })),
}))

export default useStore
